module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9bd126cef4ccc5aad4387dd11adb56f9.gif";